import * as types from '../../action/actionTypes';
import initialState from './../initialState';

export default function ViewDashboardReducer(state = initialState.Dashboards, action) {
    switch (action.type) {
        case types.GET_DASHBOARD_BY_ID_SUCCESSFUL: return {
            Current: action.getResponse
        };
        case types.GET_DASHBOARD_BY_PATH_SUCCESSFUL: return {
            Current: action.getResponse
        };
        default : return state; 
    }   
}
